import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { extensionOptionActions } from '../state/extension-option.actions';
import { extensionOptionSelectors } from '../state/extension-option.reducer';
import { EagerMultiSelectDataSource } from './eager-multi-select-data-source';

export class ExtensionMultiSelectDataSource extends EagerMultiSelectDataSource<ExtensionOption> {
   constructor(store: Store<AppState>, filterOverrides: string[]) {
      super(store, extensionOptionActions, extensionOptionSelectors);
      this.filterOverrides = filterOverrides;
   }

   compareWith(a: ExtensionOption, b: ExtensionOption): boolean {
      return a.extensionId === b.extensionId;
   }
}
